import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    position: absolute !important;
    top: 110px !important;
    left: 0;
  `,
  modal: css`
    width: 80%;
    max-width: 400px;
    padding: 8px 16px;
    text-align: center;
    background-color: ${colors.white};
    border-radius: 5px;
    box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3);
    margin: 0 auto;
  `,
  description: css`
    color: ${colors.slate};
  `,
};

export default styles;
